import { useRef, useEffect } from 'react'
import { getPageSource, track } from '@mc/track-event'
import useSticky from 'components/Sticky/useSticky'

export const STICKY_FOOTER_TYPES = {
  FREE_TRIAL: 'free-trial',
  PROMOTION: 'promotion',
  BOGO: 'bogo',
  QUIZ_ENTRY_EXP: 'quiz-entry-exp', // pen-5646_v1_quiz_entry_sticky_footer
  DEFAULT: 'default',
} as const

type StickyFooterType =
  (typeof STICKY_FOOTER_TYPES)[keyof typeof STICKY_FOOTER_TYPES]

export const useTrackStickyFooterViewed = (type: StickyFooterType) => {
  const stickyIsActive = useSticky()
  const alreadyTracked = useRef(false)

  useEffect(() => {
    if (!alreadyTracked.current && stickyIsActive) {
      track('Sticky Footer Viewed', {
        page_source: getPageSource(),
        type,
      })
      alreadyTracked.current = true
    }
  }, [stickyIsActive, type])
}
